import { createContext } from 'react';

export const MenuStateContext = createContext();
